// Application constants
export const DEFAULT_CONTENT_KEY = 'content-initial';

/** When false, hides all audio play buttons (words, toolbar, etc.) */
export const enableAudio = false;
